/**
 * Unallocated 0€ entry still eligible for invoicing (info line or description post).
 * Mirrors backend `isOpenZeroAmountLedgerEntry`. Active allocation = non-canceled invoice
 * that is not a reversal child; allocations without status still count as claimed.
 */
export function isOpenZeroAmountLedgerEntry(entry: {
  excludedFromReconciliation?: boolean;
  invoiceAllocations?: Array<{
    invoice?: { status?: string; originalInvoice?: unknown } | null;
  }>;
}): boolean {
  if (entry.excludedFromReconciliation) {
    return false;
  }
  return !entry.invoiceAllocations?.some(
    ({ invoice }) => invoice?.status !== 'CANCELED' && !invoice?.originalInvoice,
  );
}

/** Money left to invoice, or an open 0€ line that still needs an invoice item. */
export function isLedgerEntryEligibleForInvoicing(entry: {
  amountToInvoice: number;
  excludedFromReconciliation?: boolean;
  invoiceAllocations?: Array<{
    invoice?: { status?: string; originalInvoice?: unknown } | null;
  }>;
}): boolean {
  return entry.amountToInvoice !== 0 || isOpenZeroAmountLedgerEntry(entry);
}
